/** Иконка VK. */
export function VkIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width={24} height={24} rx={6} fill="#0077FF" />
      <path
        d="M12.73 16.5h1.22s.37-.04.56-.24c.17-.18.17-.52.17-.52s-.02-1.58.71-1.81c.72-.23 1.64 1.53 2.62 2.2.74.52 1.3.4 1.3.4l2.62-.04s1.37-.08.72-1.16c-.05-.09-.38-.8-1.95-2.26-1.64-1.53-1.42-1.28.55-3.93.12-.16 1.95-3.15.9-3.68-.25-.13-.43-.21-1.3-.21h-2.82s-.21-.03-.36.07c-.15.09-.24.3-.24.3s-.43 1.15-.99 2.13c-1.2 2.07-1.68 2.18-1.88 2.05-.46-.3-.34-1.2-.34-1.84 0-2-.3-2.67-.58-2.95-.2-.2-.47-.32-.8-.34-.26-.01-.68-.03-1.06-.03-1.07 0-1.78.17-2.15.53-.25.24-.37.5-.37.5s-.14.31-.06.47c.1.22.28.27.5.46.3.26.4.47.46.76.15.67.15 1.22.15 1.22s.09 2.31-.2 2.6c-.2.2-.48.07-1.14-.22-1.12-.5-1.8-1.76-2.48-2.96-.35-.62-.69-1.33-.69-1.33s-.06-.14-.16-.23c-.13-.11-.3-.15-.3-.15H4.08s-.45.01-.61.21c-.14.18-.01.55-.01.55s2.03 4.75 4.33 7.14c2.11 2.2 4.51 2.05 4.51 2.05h1.08z"
        fill="#fff"
      />
    </svg>
  );
}
